import type { ZodIssueMetadata } from '@safc/configuration';
import { useState } from 'react';

import { getInitialIssueData } from './initialIssueData.js';
import {
  getIssueModalSettings,
  type IssueModalMode,
} from './issueModalMode.js';

export const useIssueModalEffects = ({
  initialIssueMetadata,
  accountId,
  mode,
}: {
  initialIssueMetadata: Partial<ZodIssueMetadata>;
  accountId?: string;
  mode: IssueModalMode;
}) => {
  const { showTerms } = getIssueModalSettings(mode);
  const [checked, setChecked] = useState(showTerms ? false : true);
  const [step, setStep] = useState(0);
  const [issueData, setIssueData] = useState<ZodIssueMetadata | null>(null);

  const initialIssueData = getInitialIssueData({ initialIssueMetadata, accountId, mode });

  return {
    checked,
    setChecked,
    step,
    setStep,
    initialIssueData,
    setIssueData,
    issueData,
  };
};
